module.exports = "/lucky-balls/img/regular_game/footer.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/footer.png
// module id = 1093
// module chunks = 2